module.exports = __webpack_public_path__ + "img/accountTransactions.7e3a12a2.svg";